export default __webpack_public_path__ + "static/media/tony-4.54b22826.jpg";